import Vue from 'vue';

export default {
  state: {
    formErrors: {},
    formRejected: {} // Отдельный стейт для rejected-values. Сделано отдельно чтобы не ломать уже имеющиеся обработки ошибок на страницах
  },
  mutations: {
    setFormErrors(state, payload) {
      Vue.set(state.formErrors, payload.formName, {});
      Vue.set(state.formRejected, payload.formName, {});

      if (payload.errorResponse && payload.errorResponse.length > 0) {
        payload.errorResponse.forEach((item) => {
          if (!state.formErrors[payload.formName][item.field]) {
            Vue.set(state.formErrors[payload.formName], item.field, item.message);
          } else {
            let fieldMessages =
              typeof state.formErrors[payload.formName][item.field] === 'string'
                ? { message1: state.formErrors[payload.formName][item.field] }
                : state.formErrors[payload.formName][item.field];

            let messageIndex = Object.keys(fieldMessages).length;
            let messageKey = `message${messageIndex + 1}`;
            Vue.set(fieldMessages, messageKey, item.message);
            Vue.set(state.formErrors[payload.formName], item.field, fieldMessages);
          }

          if (item.rejected) {
            Vue.set(state.formRejected[payload.formName], item.field, item.rejected);
          }
        });
      }
    }
  },
  actions: {
    setFormErrors(state, payload) {
      state.commit('setFormErrors', payload);
    }
  },
  getters: {
    getFormErrors: (state) => (formName) => state.formErrors[formName],
    getRejectedValues: (state) => (formName) => state.formRejected[formName]
  }
};
